import axios from "axios";
const apiURL = process.env.REACT_APP_API_URL;

const BearerToken = () =>
  localStorage.getItem("jwt")
    ? JSON.parse(localStorage.getItem("jwt")).token
    : false;
const Headers = () => {
  return {
    headers: {
      token: `Bearer ${BearerToken()}`,
    },
  };
};

export const getAllGallery = async () => {
  try {
    let res = await axios.get(`${apiURL}/api/gallery/all-gallery`, Headers());
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const createGallery = async (mediaFile) => {
  let formData = new FormData();
  formData.append("media", mediaFile);
  try {
    let res = await axios.post(`${apiURL}/api/gallery/add-gallery`, formData, Headers());
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const deleteGallery = async (gId) => {
  try {
    let res = await axios.post(`${apiURL}/api/gallery/delete-gallery`, { gId }, Headers());
    return res.data;
  } catch (error) {
    console.log(error);
  }
};
